import styled from '@emotion/styled';

const SectionHeading = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '1.5rem',
});

export default SectionHeading;
